import { BLOB_ID } from '../../../constants/blobId';
import { ChatMessageValidationError } from '../../../errors';
import { showAlert } from '../../../slices/alertSlice';
import { EAlert } from '../../../types/alert';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageValidationError } from '../actions';
import { trackOpenNoLinksPopup } from '../tracking';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertValidationErrorStatus =
  (response: TFirstMessageResponse, { domain, telemetry, text }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.ValidationError) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendHasExternalLink);

      const { errors } = response.data;

      const isLinkError = errors?.some((error: { code: string }) => error.code === 'messageHasLinkToAnotherService');

      if (isLinkError) {
        dispatch(setFirstMessageValidationError());
        dispatch(showAlert({ type: EAlert.MessageHasLinkToAnotherService, message: text, chatId: BLOB_ID }));

        trackOpenNoLinksPopup();
      } else {
        telemetry.increment(ETelemetryEvents.ChatFirstMessageSendValidationError);
      }

      const error = new ChatMessageValidationError({
        message: 'Ошибка валидации сообщения',
        domain,
      });

      logger.error(error);
    }
  };
